// extracted by mini-css-extract-plugin
module.exports = {"label":"StatusLabel_label__3O6e9","colorActive":"StatusLabel_colorActive__2zuph","colorDraft":"StatusLabel_colorDraft__39wZo","colorInactive":"StatusLabel_colorInactive__X5qjM"};